export interface Province {
  code: string;
  name: string;
  region: string;
}

export interface Region {
  code: string;
  name: string;
}

export const ITALIAN_REGIONS: Region[] = [
  { code: 'ABR', name: 'Abruzzo' },
  { code: 'BAS', name: 'Basilicata' },
  { code: 'CAL', name: 'Calabria' },
  { code: 'CAM', name: 'Campania' },
  { code: 'EMR', name: 'Emilia-Romagna' },
  { code: 'FVG', name: 'Friuli-Venezia Giulia' },
  { code: 'LAZ', name: 'Lazio' },
  { code: 'LIG', name: 'Liguria' },
  { code: 'LOM', name: 'Lombardia' },
  { code: 'MAR', name: 'Marche' },
  { code: 'MOL', name: 'Molise' },
  { code: 'PIE', name: 'Piemonte' },
  { code: 'PUG', name: 'Puglia' },
  { code: 'SAR', name: 'Sardegna' },
  { code: 'SIC', name: 'Sicilia' },
  { code: 'TOS', name: 'Toscana' },
  { code: 'TAA', name: 'Trentino-Alto Adige' },
  { code: 'UMB', name: 'Umbria' },
  { code: 'VDA', name: "Valle d'Aosta" },
  { code: 'VEN', name: 'Veneto' }
];

export const ITALIAN_PROVINCES: Province[] = [
  // Abruzzo
  { code: 'AQ', name: "L'Aquila", region: 'ABR' },
  { code: 'CH', name: 'Chieti', region: 'ABR' },
  { code: 'PE', name: 'Pescara', region: 'ABR' },
  { code: 'TE', name: 'Teramo', region: 'ABR' },
  
  // Basilicata
  { code: 'MT', name: 'Matera', region: 'BAS' },
  { code: 'PZ', name: 'Potenza', region: 'BAS' },
  
  // Calabria
  { code: 'CZ', name: 'Catanzaro', region: 'CAL' },
  { code: 'CS', name: 'Cosenza', region: 'CAL' },
  { code: 'KR', name: 'Crotone', region: 'CAL' },
  { code: 'RC', name: 'Reggio Calabria', region: 'CAL' },
  { code: 'VV', name: 'Vibo Valentia', region: 'CAL' },
  
  // Campania
  { code: 'AV', name: 'Avellino', region: 'CAM' },
  { code: 'BN', name: 'Benevento', region: 'CAM' },
  { code: 'CE', name: 'Caserta', region: 'CAM' },
  { code: 'NA', name: 'Napoli', region: 'CAM' },
  { code: 'SA', name: 'Salerno', region: 'CAM' },
  
  // Emilia-Romagna
  { code: 'BO', name: 'Bologna', region: 'EMR' },
  { code: 'FE', name: 'Ferrara', region: 'EMR' },
  { code: 'FC', name: 'Forlì-Cesena', region: 'EMR' },
  { code: 'MO', name: 'Modena', region: 'EMR' },
  { code: 'PR', name: 'Parma', region: 'EMR' },
  { code: 'PC', name: 'Piacenza', region: 'EMR' },
  { code: 'RA', name: 'Ravenna', region: 'EMR' },
  { code: 'RE', name: 'Reggio Emilia', region: 'EMR' },
  { code: 'RN', name: 'Rimini', region: 'EMR' },
  
  // Friuli-Venezia Giulia
  { code: 'GO', name: 'Gorizia', region: 'FVG' },
  { code: 'PN', name: 'Pordenone', region: 'FVG' },
  { code: 'TS', name: 'Trieste', region: 'FVG' },
  { code: 'UD', name: 'Udine', region: 'FVG' },
  
  // Lazio
  { code: 'FR', name: 'Frosinone', region: 'LAZ' },
  { code: 'LT', name: 'Latina', region: 'LAZ' },
  { code: 'RI', name: 'Rieti', region: 'LAZ' },
  { code: 'RM', name: 'Roma', region: 'LAZ' },
  { code: 'VT', name: 'Viterbo', region: 'LAZ' },
  
  // Liguria
  { code: 'GE', name: 'Genova', region: 'LIG' },
  { code: 'IM', name: 'Imperia', region: 'LIG' },
  { code: 'SP', name: 'La Spezia', region: 'LIG' },
  { code: 'SV', name: 'Savona', region: 'LIG' },
  
  // Lombardia
  { code: 'BG', name: 'Bergamo', region: 'LOM' },
  { code: 'BS', name: 'Brescia', region: 'LOM' },
  { code: 'CO', name: 'Como', region: 'LOM' },
  { code: 'CR', name: 'Cremona', region: 'LOM' },
  { code: 'LC', name: 'Lecco', region: 'LOM' },
  { code: 'LO', name: 'Lodi', region: 'LOM' },
  { code: 'MN', name: 'Mantova', region: 'LOM' },
  { code: 'MI', name: 'Milano', region: 'LOM' },
  { code: 'MB', name: 'Monza e Brianza', region: 'LOM' },
  { code: 'PV', name: 'Pavia', region: 'LOM' },
  { code: 'SO', name: 'Sondrio', region: 'LOM' },
  { code: 'VA', name: 'Varese', region: 'LOM' },
  
  // Marche
  { code: 'AN', name: 'Ancona', region: 'MAR' },
  { code: 'AP', name: 'Ascoli Piceno', region: 'MAR' },
  { code: 'FM', name: 'Fermo', region: 'MAR' },
  { code: 'MC', name: 'Macerata', region: 'MAR' },
  { code: 'PU', name: 'Pesaro e Urbino', region: 'MAR' },
  
  // Molise
  { code: 'CB', name: 'Campobasso', region: 'MOL' },
  { code: 'IS', name: 'Isernia', region: 'MOL' },
  
  // Piemonte
  { code: 'AL', name: 'Alessandria', region: 'PIE' },
  { code: 'AT', name: 'Asti', region: 'PIE' },
  { code: 'BI', name: 'Biella', region: 'PIE' },
  { code: 'CN', name: 'Cuneo', region: 'PIE' },
  { code: 'NO', name: 'Novara', region: 'PIE' },
  { code: 'TO', name: 'Torino', region: 'PIE' },
  { code: 'VB', name: 'Verbano-Cusio-Ossola', region: 'PIE' },
  { code: 'VC', name: 'Vercelli', region: 'PIE' },
  
  // Puglia
  { code: 'BA', name: 'Bari', region: 'PUG' },
  { code: 'BT', name: 'Barletta-Andria-Trani', region: 'PUG' },
  { code: 'BR', name: 'Brindisi', region: 'PUG' },
  { code: 'FG', name: 'Foggia', region: 'PUG' },
  { code: 'LE', name: 'Lecce', region: 'PUG' },
  { code: 'TA', name: 'Taranto', region: 'PUG' },
  
  // Sardegna
  { code: 'CA', name: 'Cagliari', region: 'SAR' },
  { code: 'CI', name: 'Carbonia-Iglesias', region: 'SAR' },
  { code: 'VS', name: 'Medio Campidano', region: 'SAR' },
  { code: 'NU', name: 'Nuoro', region: 'SAR' },
  { code: 'OG', name: 'Ogliastra', region: 'SAR' },
  { code: 'OT', name: 'Olbia-Tempio', region: 'SAR' },
  { code: 'OR', name: 'Oristano', region: 'SAR' },
  { code: 'SS', name: 'Sassari', region: 'SAR' },
  
  // Sicilia
  { code: 'AG', name: 'Agrigento', region: 'SIC' },
  { code: 'CL', name: 'Caltanissetta', region: 'SIC' },
  { code: 'CT', name: 'Catania', region: 'SIC' },
  { code: 'EN', name: 'Enna', region: 'SIC' },
  { code: 'ME', name: 'Messina', region: 'SIC' },
  { code: 'PA', name: 'Palermo', region: 'SIC' },
  { code: 'RG', name: 'Ragusa', region: 'SIC' },
  { code: 'SR', name: 'Siracusa', region: 'SIC' },
  { code: 'TP', name: 'Trapani', region: 'SIC' },
  
  // Toscana
  { code: 'AR', name: 'Arezzo', region: 'TOS' },
  { code: 'FI', name: 'Firenze', region: 'TOS' },
  { code: 'GR', name: 'Grosseto', region: 'TOS' },
  { code: 'LI', name: 'Livorno', region: 'TOS' },
  { code: 'LU', name: 'Lucca', region: 'TOS' },
  { code: 'MS', name: 'Massa-Carrara', region: 'TOS' },
  { code: 'PI', name: 'Pisa', region: 'TOS' },
  { code: 'PT', name: 'Pistoia', region: 'TOS' },
  { code: 'PO', name: 'Prato', region: 'TOS' },
  { code: 'SI', name: 'Siena', region: 'TOS' },
  
  // Trentino-Alto Adige
  { code: 'BZ', name: 'Bolzano', region: 'TAA' },
  { code: 'TN', name: 'Trento', region: 'TAA' },
  
  // Umbria
  { code: 'PG', name: 'Perugia', region: 'UMB' },
  { code: 'TR', name: 'Terni', region: 'UMB' },
  
  // Valle d'Aosta
  { code: 'AO', name: 'Aosta', region: 'VDA' },
  
  // Veneto
  { code: 'BL', name: 'Belluno', region: 'VEN' },
  { code: 'PD', name: 'Padova', region: 'VEN' },
  { code: 'RO', name: 'Rovigo', region: 'VEN' },
  { code: 'TV', name: 'Treviso', region: 'VEN' },
  { code: 'VE', name: 'Venezia', region: 'VEN' },
  { code: 'VR', name: 'Verona', region: 'VEN' },
  { code: 'VI', name: 'Vicenza', region: 'VEN' }
];

export const getProvincesByRegion = (regionCode: string): Province[] => {
  return ITALIAN_PROVINCES.filter(province => province.region === regionCode);
};

export const getRegionByCode = (code: string): Region | undefined => {
  return ITALIAN_REGIONS.find(region => region.code === code);
};

/** Regione da mostrare: il codice salvato ("LOM") diventa "Lombardia"; ogni altro valore resta com'è. */
export const regionDisplayName = (value: string | null | undefined): string => {
  if (!value) return '';
  return getRegionByCode(value.trim().toUpperCase())?.name ?? value;
};

export const getProvinceByCode = (code: string): Province | undefined => {
  return ITALIAN_PROVINCES.find(province => province.code === code);
};